import React from 'react';
import { Box, Button } from '@mui/material';
import { Link } from '@utils/AvRouter';

const AlertScoreEmptyState = () => (
  <>
    <Box sx={{ fontWeight: 600 }}>Ready to see the full picture?</Box>
    <div>
      <span>Your scoring isn&#39;t configured. </span>
      <Button variant="primaryText" component={Link} to="/$accountId/threats/settings/alert-score" sx={{ lineHeight: 0, mt: '-2px' }}>
        Configure score settings
      </Button>{' '}
      now to start getting all the powerful data you need.
    </div>
  </>
);

export default AlertScoreEmptyState;
